import { render } from "./Player.vue?vue&type=template&id=3143a12b&scoped=true"
import script from "./player.js?vue&type=script&lang=js&external"
export * from "./player.js?vue&type=script&lang=js&external"

import "./Player.vue?vue&type=style&index=0&id=3143a12b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3143a12b"]])

export default __exports__